/**
 * Returns true only for native deep link URIs (e.g. spark://, sleepio://).
 * Uses an allowlist to prevent open redirect attacks.
 */
export const isSafeRedirectUri = (uri: string): boolean => {
  try {
    const url = new URL(uri);
    if (url.username || url.password) {
      return false;
    }
    const allowed = new Set(['spark:', 'sleepio:', 'sleep-companion:']);
    return allowed.has(url.protocol);
  } catch {
    return false;
  }
};

/**
 * Builds "?redirect_to=<encoded>" for a safe deep-link URI, else "".
 * Always validates so it is safe to call with raw URL input. Used to thread
 * the deep-link redirect target across activation step navigations.
 */
export const buildRedirectParam = (redirectTo: string | null | undefined): string => {
  if (!redirectTo || !isSafeRedirectUri(redirectTo)) {
    return '';
  }
  return `?redirect_to=${encodeURIComponent(redirectTo)}`;
};
